// extracted by mini-css-extract-plugin
export default {"inputWrapper":"_16KVIa6ObhuMuCWqSorhWK"};